import { render, staticRenderFns } from "./PushNotif.vue?vue&type=template&id=67710686&scoped=true"
import script from "./PushNotif.vue?vue&type=script&lang=js"
export * from "./PushNotif.vue?vue&type=script&lang=js"
import style0 from "./PushNotif.vue?vue&type=style&index=0&id=67710686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67710686",
  null
  
)

export default component.exports